import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomSelect from '../../../Forms/Element/CustomSelect';
import axiosInstance from '../../../../../services/AxiosInstance';
import Api from '../../../../../constants/Api';
import { SearchOperation } from '../../../../../utils/ApiUtils';

const SELECT_ALL_VALUE = "__ALL__";

/**
 * Componente responsável por listar os colaboradores.
 */
const EmployeeSelect = (props) => {

  const { t } = useTranslation();
  const [entities, setEntities] = useState([]);
  const {
    branch,
    includeSelectAll,
    isDisabled,
    isMulti,
    onChange,
    value,
    filterProvidesService = true,
    // Texto do campo vazio. Em formulários onde vazio significa "todos", dizer isso no próprio
    // campo evita um aviso à parte explicando a convenção.
    placeholder
  } = props;

  const branchId = branch?.id || branch?.value || null;

  useEffect(() => {
    function findAll() {
      setEntities([]);

      let filters = [];
      if (branchId) {
        filters.push({
          field: "branches.id",
          value: branchId,
          operation: SearchOperation.EQUAL
        });
      }
      if (filterProvidesService) {
        filters.push({
          field: "providesService",
          value: true,
          operation: SearchOperation.EQUAL
        });
      }

      const request = filters.length > 0
        ? axiosInstance.post(Api.main.employee + "/findByFilters", { filters })
        : axiosInstance.get(Api.main.employee);

      request
        .then(response => {
          const options = response.data.map(employee => ({
            value: employee.id,
            label: employee.fullName,
            // Dias de atendimento do colaborador, para a agenda avisar antes de salvar
            // quando a data escolhida cai num dia em que ele não trabalha.
            workDays: employee.workDays || [],
            // Férias, para a tela de agendamento recusar a data antes de enviar e dizer
            // até quando o colaborador está fora.
            vacationEnabled: employee.vacationEnabled,
            vacationStartDate: employee.vacationStartDate,
            vacationReturnDate: employee.vacationReturnDate
          }));

          setEntities(options);
        });
    }

    findAll();
  }, [branchId]);

  const options = includeSelectAll && entities.length > 0
    ? [{ value: SELECT_ALL_VALUE, label: t("all") }, ...entities]
    : entities;

  const allSelected = includeSelectAll
    && isMulti
    && entities.length > 0
    && Array.isArray(value)
    && value.length === entities.length
    && entities.every(entity => value.some(selected => selected.value === entity.value));

  const selectValue = allSelected
    ? [{ value: SELECT_ALL_VALUE, label: `${t("all")} (${entities.length})` }]
    : value;

  const handleChange = (selected) => {
    if (includeSelectAll && isMulti && selected?.some(option => option.value === SELECT_ALL_VALUE)) {
      onChange(entities);
      return;
    }

    onChange(selected);
  };

  return (
    <CustomSelect
      options={options}
      value={selectValue}
      onChange={handleChange}
      isClearable
      isMulti={isMulti}
      placeholder={placeholder || t("select")}
      isDisabled={isDisabled}
    />
  )
}

export default EmployeeSelect;
